import { get, put, } from "@/api/axios";

// 获取故障列表
export const list = params => get('/web/fault/handle/list', params);

// 扣除押金
export const deductionMoneyHandle = params => put('/web/fault/handle/commit', params);


